import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { Router } from '@angular/router'

@Component({
  selector: 'flo-personalization-cta',
  templateUrl: './personalization-cta.component.html',
  styleUrls: ['./personalization-cta.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonalizationCtaComponent {
  @Input() image: string
  @Input() title: string
  @Input() subtitle: string
  @Input() btnTitle: string
  @Input() href: string

  constructor(private readonly router: Router) {}

  public onCtaClick() {
    this.router.navigateByUrl(this.href)
  }
}
